import React, {Component} from 'react';
import styles from "./login.module.css";
import bg from '../../img/background.jpg';
import defaultImg from '../../img/bee.png';
import logoTitle from '../../img/logotitle.png';
import logo2 from '../../img/xingfutianyuan.png';
import phone from '../../img/phone.svg';
import code from '../../img/code.svg';
import qrcode from '../../img/qrcode.png';
import Timer from './Timer.jsx';
import {FILE_URL} from "../../util/constants";
import MyImg from "../myimg/myimg.jsx";
import logoNew from '../../img/logo_new.png';
import loadingLogo from '../../img/loading-title.png';
import loadingXiaoxun from '../../img/loading-xiaoxun.png';
import icRefresh from '../../img/ic_refresh.png';


import QRCode  from 'qrcode.react';



const Login = props => (

    <div className={styles.root}>
        <img className={styles.bg} src={bg}/>
        <img className={styles["logo-new"]} src={logoNew}/>
        {props.showLoading ?
            <div className={styles["container-loading"]}>
                <img className={styles["loading-logo"]} src={loadingLogo}/>
                <img className={styles.xiaoxun} src={loadingXiaoxun}/>
                <div className={styles["loading-start"]}>正在启动程序</div>
            </div> :


            <div className={styles["container-login"]}>

                <div className={styles["container-left"]}>
                    <div className={styles["div-clear"]}>
                        <div className={styles["text-jilu"]}>历史记录</div>
                        <div className={styles.clear} onClick={props.clear}>×</div>
                    </div>

                    <div className={styles["list-wrapper"]}>
                        {
                            props.recordList.map((item, index, array) => {
                                return (
                                    <div className={styles.list} onClick={props.loginByRecord.bind(null, item.phone)}>
                                        {/*<img className={styles["list-img"]}*/}
                                        {/*src={item.teacherimg == '' || item.teacherimg == null ? defaultImg : FILE_URL + item.teacherimg}/>*/}

                                        <MyImg src={FILE_URL + item.teacherimg}/>


                                        <div className={styles.name}>{item.name}</div>


                                    </div>
                                )
                            })
                        }
                    </div>


                </div>

                <div className={styles["container-right"]}>
                    <img className={styles["logo-img"]} src={logo2}/>

                    <div className={styles["container-tab"]}>

                        <div className={styles["div-tab"]}>
                        <div className={props.tab == 1 ? styles["tab-selected"] : styles.tab}
                        onClick={props.clickTab.bind(null, 1)}>扫码登录
                        </div>
                        {props.tab == 1 ? <div className={styles.line}></div> : null}

                        </div>


                        <div className={styles["div-tab"]}>
                            <div className={props.tab == 2 ? styles["tab-selected"] : styles.tab}
                                 onClick={props.clickTab.bind(null, 2)}>账户登录
                            </div>
                            {props.tab == 2 ? <div className={styles.line}></div> : null}
                        </div>
                    </div>

                    {props.tab == 2 ? <div>
                        <div className={styles["div-phone"]}>
                            <img className={styles["img-phone"]} src={phone}/>
                            <input
                                className={styles["input-phone"]}
                                placeholder='请输入手机号'
                                autoComplete="off"
                                maxLength='11'
                                onChange={(e) => {
                                    props.phoneNumberChange(e.target.value);
                                }}
                                value={props.phoneNumberValue}
                            />
                        </div>

                        <div className={styles["div-phone"]}>
                            <img className={styles["img-code"]} src={code}/>
                            <input
                                maxLength='6'
                                autoComplete="off"
                                className={styles["input-code"]}
                                placeholder='短信验证码'
                                value={props.codeValue}
                                onChange={(e) => {
                                    props.codeChange(e.target.value);
                                }}
                            />
                            <Timer onRef={props.onRef} sendMsg={props.sendMsg} onErrorMsg={props.onErrorMsg}/>
                        </div>

                        <div className={styles["bt-login"]} onClick={props.loginByPwd}>登录</div>

                    </div> : null}

                    {props.tab == 1 ? <div className={styles["container-qrcode"]}>

                            <QRCode
                                className={styles["img-qrcode"]}
                                value={props.QRCodeContent}
                            />
                            {!props.QRStatus ?
                            <div className={styles["div-ceng"]}>
                                <img className={styles["bt-refresh"]} src={icRefresh} onClick={props.refreshQRCode}/>
                            </div>:null}


                        {props.QRStatus ?
                            <div className={styles["div-text"]}>
                                <div className={styles.text1}>使用幸福田园教师版APP</div>
                                <div className={styles.text2}>扫码登录</div>
                            </div>
                            :
                            <div className={styles["div-text"]}>
                                <div className={styles.text1}>二维码已失效，点击刷新</div>
                            </div>
                        }



                    </div> : null}
                </div>

            </div>
        }
    </div>

)

export default Login;
